var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-range-picker',{attrs:{"format":_vm.format,"value-format":_vm.valueFormat,"placeholder":['开始时间', '结束时间']},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }